import * as XLSX from "xlsx";

export function convertToCSV(arr) {
	const header = Object.keys(arr[0]).join(","); // Extract the keys as header
	const rows = arr.map(obj => Object.values(obj).join(",")); // Extract the values as rows
	return [header, ...rows].join("\n"); // Combine header and rows with line breaks
}

export function convertToAoa(arr) {
	const header = Object.keys(arr[0]); // Extract the keys as header
	const rows = arr.map(obj => Object.values(obj)); // Extract the values as rows
	return [header, ...rows]; // Combine header and rows with line breaks
}

export function exportToCSV(data, filename) {
	const blob = convertToCSV(data);
	const csvBlob = new Blob([blob], {type: "text/csv;charset=utf-8;"});

	if (navigator.msSaveBlob) {
		// For Microsoft Edge and IE
		navigator.msSaveBlob(csvBlob, filename);
	} else {
		// For other browsers
		const csvURL = URL.createObjectURL(csvBlob);
		const tempLink = document.createElement("a");
		tempLink.href = csvURL;
		tempLink.setAttribute("download", `${filename}.csv`);
		tempLink.click();
	}
}

export function exportToExcel(data, filename) {
	const blob = convertToAoa(data);
	// console.log(blob);

	/* create worksheet */
	var ws = XLSX.utils.aoa_to_sheet(blob);
	/* create workbook and export */
	var wb = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	XLSX.writeFile(wb, `${filename}.xlsx`);
}
